import { TextField } from '@mui/material';
import type { Condition } from '@repo/api-gw-sdk';

import { ListOperator } from '@/types/advanceFilter';

import { MultiSelect, type MultiSelectProps } from '../select/multiSelect';

export const inlineDropdownStyle = {
  boxShadow: 'none',
  '.MuiOutlinedInput-notchedOutline': { border: 0 },
};

export const FreeTextCondition = ({
  condition,
  onChange,
}: {
  condition: Condition;
  onChange: (condition: Condition) => void;
}) => (
  <TextField
    sx={inlineDropdownStyle}
    value={condition.value?.[0] ?? ''}
    onChange={(event) =>
      onChange({ ...condition, value: [event.target.value] })
    }
  />
);

export const MultiSelectCondition = ({
  options,
  condition,
  onChange,
  showImagesInRender,
}: {
  options: MultiSelectProps['options'];
  condition: Condition;
  onChange: (condition: Condition) => void;
  showImagesInRender?: boolean;
}) => (
  <MultiSelect
    showImagesInRender={showImagesInRender}
    sx={{ ...inlineDropdownStyle, fontWeight: 'bold' }}
    MenuProps={{ disablePortal: true }}
    value={condition.value ?? []}
    multiple={
      condition.operator === ListOperator.In.toString() ||
      condition.operator === ListOperator.NotIn.toString() ||
      condition.operator === ListOperator.Contains.toString() ||
      condition.operator === ListOperator.ContainsNoneOf.toString() ||
      condition.operator === ListOperator.ContainsAnyOf.toString() ||
      condition.operator === ListOperator.NotContains.toString()
    }
    onChange={(event) =>
      onChange({
        ...condition,
        value: event.target.value as string[],
      })
    }
    options={options}
  />
);
